import * as PIXI from "pixi.js";
import Tween from "tween.ts";
import Animation from "./Animation";


export default class HTPAboutFwTextAnimation extends Animation {
  constructor(Text: PIXI.Text, delay: number) {
    super();
    setTimeout(() => {
      new Tween.Tween(Text)
        .to({
          width: Text.width * 1,
          height: Text.height * 1
        }, 1000)
        .easing(Tween.Easing.Circular.Out)
        .yoyo(true)
        .repeat(Infinity)
        .start();
    }, delay);
  }
}